import React from 'react'
import moment from 'moment'
import AnDateTimePicker from '../../../../components/DateTime/DateTimePicker'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const DutyTimes = ({ form, handleChange }) => {
  const timeDiff = moment(form.end).diff(form.start, 'hours')
  return (
    <>
      <Grid item xs={12} lg={5}>
        <AnDateTimePicker
          label="Start Time"
          date={form.start}
          onChange={(newVal) => handleChange('start', moment(newVal))}
          slotProps={{ textField: { fullWidth: true } }}
          fullWidth
          error={!form?.start || moment(form.start).isSameOrAfter(form.end)}
        />
      </Grid>
      <Grid item xs={12} lg={5}>
        <AnDateTimePicker
          label="End Time"
          date={form.end}
          onChange={(newVal) => handleChange('end', moment(newVal))}
          slotProps={{ textField: { fullWidth: true } }}
          fullWidth
          error={!form?.end || moment(form.end).isSameOrBefore(form.start)}
        />
      </Grid>
      <Grid item xs={12} lg={2}>
        <Stack alignItems="center" direction={{ xs: 'row', lg: 'column' }}>
          <Typography variant="title2" color={timeDiff < 0 && 'error'}>
            {timeDiff}
          </Typography>
          <Typography>hours</Typography>
        </Stack>
      </Grid>
    </>
  )
}

export default DutyTimes
